import { IResponseStatus } from "../Common/BridgeInterface";

export const ROAMING_ACCOUNTS_SUFFIX = '/Citrix/Roaming/Accounts';
export const INDEX_URL = '/vpn/index.html';
export const CLOUD_HEADER_NAME = 'X-StoreFront-InstanceId';
export const DISCOVER_PROBE_SUFFIX = '/AGServices/discover';
export const INDEX_SUFFIX = '/vpn/index.html';
export const SELF_DECLARED_AUTH_TYPE_HEADER = 'X-Citrix-AM-GatewayAuthType';
export const CGI_AUTH_SUFFIX = '/cgi/authenticate';
export const LABEL_TYPES =
	'confirmation,error,heading,heading2,hyperlink,image,information,none,plain,warning';
export const CREDENTIAL_TYPES =
	'domain,newpassword,none,passcode,password,pin,realm,rsa-next-passcode,rsa-next-tokencode,rsa-passcode,rsa-pin,savecredentials,textcredential,username,webview';
export const ACCEPT_AUTHENTICATE_RESPONSE =
	'application/vnd.citrix.authenticateresponse-1+xml';
export const ACCEPT_ROAMINGACCOUNTS_RESPONSE =
	'application/vnd.citrix.roamingaccounts+xml';
export const DISCOVERY_RESPONSE_TYPE = 'application/vnd.citrix.discovery+xml';
export const SUPPORTED_LANGUAGES = [
	'de',
	'en',
	'es',
	'fr',
	'it',
	'ja',
	'ko',
	'nl',
	'pt-BR',
	'ru',
	'zh-CN',
	'zh-TW',
];

export enum AccountType {
	Email = 'email',
	Url = 'url',
	StoreURLWithoutCertValidation = 'StoreURLWithoutCertValidation',
}

export enum ViewEnum {
	Error = 'error',
	SignIn = 'signin',
	Loading = 'loading',
	Splash = 'splash',
	EPAWait = 'EPAWait',
	BlockLogin = 'blocklogin',
	ConfigurationWizard = 'configurationWizard',
}

export const ResponseStatus: IResponseStatus = {
	Success: 0,
	Failure: 1,
};

export enum PerformanceEvents {
	AddAccountFormRendered = 'AddAccountForm_Rendered',
	AddAccountFlowStarted = 'AddAccountFlow_Started',
}

export enum NativeWebView {
	WMAuthView = 'WMAuthView',
	Restore = 'Restore',
}
